export const verbrauch = {
    VerbrauchClass: {
        url: "StromVerbrauch/verbrauch",
        defaultSegment: "StromVerbrauch",
        forceRefresh: false,
        receiveType: 'RECEIVE_Verbrauch_verbrauchReducer'
    }
};